import ApiService from "./ApiService";

export async function apiLogin(data) {
  return ApiService.fetchData({
    url: "/common/auth/login",
    method: "post",
    data,
  });
}
